



export const UNITWEIGHT_VOLUME_MAIN = 10;
export const UNITWEIGHT_VOLUME_ROOF = 15;
export const UNITWEIGHT_VOLUME_SUB = 12;


// export const UNITWEIGHT_DRIVEFLOOR = 300;
// export const UNITWEIGHT_NONDRIVEFLOOR = 200;
// export const UNITWEIGHT_ACCESSFLOOR = 100;

export const UNITWEIGHT_DRIVEFLOOR = 75;
export const UNITWEIGHT_NONDRIVEFLOOR = 60;
export const UNITWEIGHT_ACCESSFLOOR = 45;

export const UNITWEIGHT_CHECKEREDPLATE = 75;
export const UNITWEIGHT_GRATING = 125;
export const UNITWEIGHT_EXPANDEDMETAL = 45;

export const UNITWEIGHT_STAIR = 156.5;

export const UNITWEIGHT_HOISTBEAM = 65.5;